import { postAPI } from '../apiMethods';

export const AUTH_API = {
  login: (reqBody) => postAPI(`/api/v1/facebook-meta-ads/user/login`, reqBody),
};
